import { render, staticRenderFns } from "./putadd.vue?vue&type=template&id=2d75161c&scoped=true"
import script from "./putadd.vue?vue&type=script&lang=js"
export * from "./putadd.vue?vue&type=script&lang=js"
import style0 from "./putadd.vue?vue&type=style&index=0&id=2d75161c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d75161c",
  null
  
)

export default component.exports